export default function ClippingSVG({ isFlightDetails, isPremium }) {
  const radius = isFlightDetails ? 5 : 4;
  const diameter = 2 * radius;
  const offset = isFlightDetails ? 0 : 1;
  const cardWidth = isPremium ? 340 : 232;

  return (
    <svg width={0} height={0}>
      <defs>
        <clipPath id={`clipHalfCircles${isPremium ? 'Premium' : ''}`}>
          <path
            d={`
              M0,0 
              H${cardWidth}
              V10 
              H0 
              Z

              ${'' /* left semicircle */}
              M0,${10 - offset}
              a${radius},${radius} 0 1 0 0,-${diameter}

              ${'' /* right semicircle */}
              M${cardWidth},${offset}
              a${radius},${radius} 0 1 0 0,${diameter}
            `}
            fillRule="evenodd"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
